import { apiGet, apiPost } from '@api/api.utils'
import { IResponseCommon } from '@api/common.types'

import { IResponsePushNotificationsPublicKey } from './api.types'


const route = '/pushNotifications'


/** Получение публичного VAPID-ключа для Push API. */
export const getPushNotificationsPublicKey = (): Promise<IResponsePushNotificationsPublicKey> =>
    apiGet<IResponsePushNotificationsPublicKey>(`${route}/getPublicKey`)

/** Сохранение подписки браузера текущего оператора. */
export const subscribePushNotifications = (subscription: unknown, siteOrigin: string): Promise<IResponseCommon> =>
    apiPost<IResponseCommon>(`${route}/subscribe`, undefined, { subscription, siteOrigin })

/** Отключение подписки браузера текущего оператора. */
export const unsubscribePushNotifications = (endpoint: string): Promise<IResponseCommon> =>
    apiPost<IResponseCommon>(`${route}/unsubscribe`, undefined, { endpoint })